import { render, staticRenderFns } from "./RoleTabPanel.vue?vue&type=template&id=1ca1f2ae&scoped=true&"
import script from "./RoleTabPanel.vue?vue&type=script&lang=js&"
export * from "./RoleTabPanel.vue?vue&type=script&lang=js&"
import style0 from "./RoleTabPanel.vue?vue&type=style&index=0&id=1ca1f2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1f2ae",
  null
  
)

export default component.exports